import { render, staticRenderFns } from "./ItsContractFeeSettlement.vue?vue&type=template&id=7b706569&scoped=true&"
import script from "./ItsContractFeeSettlement.vue?vue&type=script&lang=js&"
export * from "./ItsContractFeeSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b706569",
  null
  
)

export default component.exports